import React from "react";
import ReactHtmlParser from "react-html-parser";
import replaceImageCdn from "@herb/utils/replaceImageCdn";
import HempBanSectionHead from "@herb/components/HempBan/HempBanSectionHead";
import "./index.css";

/**
 * Marker glyphs for the two card styles. The path data is the Figma export for
 * nodes 122:906 / 122:925 — inlined the same way SVGs are handled elsewhere in
 * this codebase (see AdventCalendarHero) rather than shipped as asset files.
 */
const CardMark = ({ style }) =>
  style === "red" ? (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4.5 4.5L13.5 13.5M13.5 4.5L4.5 13.5" stroke="white" />
    </svg>
  ) : (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3 9L6.75 12.75L15 4.5" stroke="#068338" />
    </svg>
  );

/**
 * "What's targeted, and what's still legal" — two gradient cards whose styling
 * is driven by the ACF `style` value ("red" / "green").
 */
const HempBanAffected = ({ whatsAffected }) => {
  if (!whatsAffected) {
    return null;
  }

  const { badgeText, heading, cards = [] } = whatsAffected;

  return (
    <section className="hb-section hb-affected">
      <div className="hb-container">
        <HempBanSectionHead badgeText={badgeText} heading={heading} />

        {cards && cards.length ? (
          <div className="hb-affected-grid">
            {cards.map((card, index) => {
              const style = card.style === "red" ? "red" : "green";

              return (
                <article
                  className={`hb-affected-card hb-affected-card--${style}`}
                  key={`${card.title || "card"}-${index}`}
                >
                  <div className="hb-affected-head">
                    <span className="hb-affected-mark">
                      <CardMark style={style} />
                    </span>
                    {card.title ? (
                      <h3 className="hb-affected-title">{card.title}</h3>
                    ) : null}
                  </div>

                  {card.rows && card.rows.length ? (
                    <ul className="hb-affected-list">
                      {card.rows.map((row, rowIndex) => (
                        <li className="hb-affected-item" key={rowIndex}>
                          <span className="hb-affected-item-icon">
                            {row.icon?.sourceUrl ? (
                              <img
                                src={replaceImageCdn(row.icon.sourceUrl)}
                                alt={row.icon.altText || ""}
                                loading="lazy"
                              />
                            ) : null}
                          </span>
                          <div className="hb-affected-item-text hb-rich">
                            {ReactHtmlParser(row.text || "")}
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </article>
              );
            })}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default HempBanAffected;
